import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/portfolio/Reveal";

export default function CTA() {
  const { t } = useLanguage();
  return <section data-testid="cta-section" className="relative studio-section bg-navy-900 overflow-hidden">
    <img src="/images/services/yacht-hero-small.webp" alt="" width="960" height="640" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover opacity-20" />
    <div className="studio-container relative">
      <Reveal className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
        <div className="max-w-xl"><p className="studio-eyebrow !text-cyan-200">{t("cta.subtitle")}</p><h2 className="studio-heading !text-white">{t("cta.title")}</h2>
          <p className="text-slate-300 mt-5 text-sm leading-relaxed">{t("cta.description")}</p>
        </div>
        <div className="flex flex-col gap-4 items-start">
          <Link to="/contact" data-testid="cta-quote-btn" className="studio-button studio-button-light">{t("cta.quote")}<ArrowUpRight size={18} /></Link>
          <a href="tel:+33756888821" data-testid="cta-call-btn" className="inline-flex gap-3 items-center min-h-11 text-white text-sm hover:text-cyan-200 transition-colors"><Phone size={17} />+33 (0)7 56 88 88 21</a>
        </div>
      </Reveal>
    </div>
  </section>;
}